module.exports = __webpack_public_path__ + "img/tlogo.30b29cae.png";